// extracted by mini-css-extract-plugin
module.exports = {"projects":"projects-module--projects--nbY6_"};